import actions from "./actions"

const initialState = {
    paymentsAll: [],
    paymentStatuses: []
};

export default function paymentsReducers(state = initialState, action:{payload: any, type: any}):any{
    switch(action.type){
        case actions.SET_ALL_PAYMENTS:
            return {...state, paymentsAll: action.payload};
        case actions.SET_PAYMENT_STATUSES:
            return {...state, paymentStatuses: action.payload};
        default:
            return state;
    }
}